const GET_VMS_AZURE_IMAGES = "GET_VMS_AZURE_IMAGES";
const GET_VMS_AZURE_IMAGES_SUCCESS = "GET_AZURE_VMS_IMAGES_SUCCESS";
const GET_VMS_AZURE_IMAGES_ERROR = "GET_AZURE_VMS_IMAGES_ERROR";

export {
  GET_VMS_AZURE_IMAGES,
  GET_VMS_AZURE_IMAGES_SUCCESS,
  GET_VMS_AZURE_IMAGES_ERROR,
};
